exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-reservation[data-v-2a581125] {\n    position: relative;\n}\n.form-reservation-anchor[data-v-2a581125] {\n    position: absolute;\n    top: -20px;\n    left: 0;\n}\n.reservation-form[data-v-2a581125] {\n    display: none;\n}\n.icon-squared-minus[data-v-2a581125] {\n    cursor: pointer;\n}\n.icon-squared-plus[data-v-2a581125] {\n    cursor: pointer;\n}\n.title[data-v-2a581125] {\n    background-color: #eee;\n    font-weight: bold;\n    padding: 5px 20px;\n}\n", ""]);

// exports
